import { View } from '@react-pdf/renderer';
import { useMemo } from 'react';
import { pdfStyles } from '../../../../../components';
import { CustomerReportResponse } from '../../../../../interfaces/reports.interface';
import { CustomerReportTableHeaderPdf } from './CustomerReportTableHeaderPdf';
import { CustomerReportTableListPdf } from './CustomerReportTableListPdf';
import { CustomerTableTotalsPdf } from './CustomerTableTotalsPdf';

interface Props {
  data: CustomerReportResponse;
}

export const CustomerReportTableSectionPdf = ({ data }: Props) => {
  const customerData = useMemo(() => data?.data?.customer, [data?.data?.customer]);
  const supplierData = useMemo(() => data?.data?.supplier, [data?.data?.supplier]);
  const traderData = useMemo(() => {
    if (customerData?.length) return customerData;
    return supplierData;
  }, [customerData, supplierData]);

  // Showing both tables is not implemented for the pdf view since it was deprecated
  return (
    <View style={pdfStyles.column}>
      <View>
        <CustomerReportTableHeaderPdf />
      </View>
      <View>
        <CustomerReportTableListPdf data={traderData} />
        <CustomerTableTotalsPdf data={traderData} />
      </View>
    </View>
  );
};
